module.exports = __webpack_public_path__ + "img/logo-icon.1b80a95b.png";